// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__33tDb","inputDescription":"styles_inputDescription__2u2vl"};